
import { services } from "../../../../../constants/services";
import { remove } from "../../../../../utils/api";

export class DeleteItemRolePermissionsService {
    async run(itemRolePermissionId: number): Promise<void> {
        await remove(`${services.users}/access/item-role-permissions`, itemRolePermissionId);
    }
}